import { gql } from '@apollo/client';

const ADD_EVENT = gql`
  mutation AddEvent($event: AddEventInput!) {
    addEvent(event: $event) {
      Success
      Errors {
        Code
        Message
      }
    }
  }
`;

export default ADD_EVENT;
